import { render } from "./CustomConfirmDialog.vue?vue&type=template&id=25102d7e&scoped=true"
import script from "./CustomConfirmDialog.vue?vue&type=script&lang=js"
export * from "./CustomConfirmDialog.vue?vue&type=script&lang=js"

import "./CustomConfirmDialog.vue?vue&type=style&index=0&id=25102d7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25102d7e"]])

export default __exports__